// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { useMemo } from "react"
import { useAuth } from "@/hooks/useAuth"
import { createApiClient } from "./client"

/** Typed BiteBalance API client bound to the current session's ID token (email claim needed by /v1/me). */
export function useApiClient() {
  const { getIdToken } = useAuth()
  return useMemo(() => createApiClient(getIdToken), [getIdToken])
}
